export default __webpack_public_path__ + "static/media/google-color.4772743f.svg";